import { render, staticRenderFns } from "./CourseVideo.vue?vue&type=template&id=40e4f5c0&scoped=true&"
import script from "./CourseVideo.vue?vue&type=script&lang=js&"
export * from "./CourseVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e4f5c0",
  null
  
)

export default component.exports